// =============================================
// Admin Layout
// Kipikid - מערכת נוכחות ילדים בגנים
// =============================================

import { useEffect } from 'react';
import {
  Home, Users, Building2, Baby, Settings,
  Landmark, Package, FolderTree, Wallet, ClipboardList, CalendarDays, Radio,
} from 'lucide-react';
import { useAuthStore } from '../../stores/authStore';
import { AdminSidebarLayout } from '../../layouts/AdminSidebarLayout';
import type { NavItem } from '../../layouts/AdminSidebarLayout';
import { adminColors } from '../../styles/colors';

const navItemsBase: (NavItem & { sysAdminOnly: boolean })[] = [
  { path: '/admin/dashboard', icon: Home, label: 'ראשי', sysAdminOnly: false },
  { path: '/admin/organizations', icon: Landmark, label: 'ארגונים', sysAdminOnly: true },
  { path: '/admin/staff', icon: Users, label: 'עובדים', sysAdminOnly: false },
  { path: '/admin/kindergartens', icon: Building2, label: 'גנים', sysAdminOnly: false },
  { path: '/admin/children', icon: Baby, label: 'ילדים', sysAdminOnly: false },
  { path: '/admin/attendance-history', icon: ClipboardList, label: 'היסטוריית נוכחות', sysAdminOnly: false },
  { path: '/admin/devices', icon: Radio, label: 'שערים', sysAdminOnly: false },
  { path: '/admin/products', icon: Package, label: 'קטלוג מוצרים', sysAdminOnly: false },
  { path: '/admin/categories', icon: FolderTree, label: 'קטגוריות הוצאה', sysAdminOnly: false },
  { path: '/admin/budget', icon: Wallet, label: 'לוח בקרה תקציבי', sysAdminOnly: false },
  { path: '/admin/calendar', icon: CalendarDays, label: 'לוח שנה ארצי', sysAdminOnly: false },
  { path: '/admin/settings', icon: Settings, label: 'הגדרות', sysAdminOnly: false },
];

export default function AdminLayout() {
  const { user } = useAuthStore();
  const isSysAdmin = !user?.organizationPublicId;

  // Filter nav items: organizations page only for SysAdmin
  const navItems = navItemsBase.filter(item => !item.sysAdminOnly || isSysAdmin);

  useEffect(() => {
    document.title = 'קיפיקיד — מנהל רשת';
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', '#2563eb');
  }, []);

  return (
    <AdminSidebarLayout
      navItems={navItems}
      title="KipiKid Admin"
      subtitle="ממשק ניהול"
      primaryColor={adminColors.primary}
      primaryLight={adminColors.primaryLight}
      loginPath="/admin/login"
      allowedRoles={['admin', 'sysadmin']}
      showOrgFilter={isSysAdmin}
      sidebarClass="sidebar-desktop"
      mainClass="main-content-desktop"
      cssPrefix="md"
    />
  );
}
